// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const AlternativeCurrencySettlementFeesTable: MarkdocTagRegistration = {
  tag: 'alternative-currency-settlement-fees-table',
  component: 'AlternativeCurrencySettlementFees',
};
